// The shared muscle taxonomy (generated copy of shared/muscles.json; see scripts/gen-shared.mjs).
import taxonomy from '../data/muscles.json';

export interface MuscleGroup { id: string; name: string }
export interface Muscle { id: string; group: string; name: string; anatomical: string; /** Plain-language line on what it does. */ does: string }

export const groups: MuscleGroup[] = taxonomy.groups;
export const muscles: Muscle[] = taxonomy.muscles.map(({ id, group, name, anatomical, does }) => ({ id, group, name, anatomical, does }));

const byId = new Map(muscles.map((m) => [m.id, m]));
const groupById = new Map(groups.map((g) => [g.id, g]));

export const muscle = (id: string) => byId.get(id);
export const group = (id: string) => groupById.get(id);
export const groupOf = (muscleId: string) => byId.get(muscleId)?.group;
export const musclesIn = (groupId: string) => muscles.filter((m) => m.group === groupId);

/** Group names for a set of muscle IDs, in taxonomy order. */
export function groupNames(muscleIds: Iterable<string>): string[] {
  const ids = new Set([...muscleIds].map(groupOf).filter(Boolean));
  return groups.filter((g) => ids.has(g.id)).map((g) => g.name);
}
